module.exports = __webpack_public_path__ + "img/40_12.7f6378f6.png";